import { createFileRoute } from '@tanstack/react-router';
import { EsqueciASenha } from '@/features/auth/componentes/RecuperarSenha';

export const Route = createFileRoute('/esqueci-a-senha')({
  component: EsqueciASenha,
});
